<template>
    <b-modal id="modal-jasa-emas" size="lg" title="Jasa Emas" hide-footer>
        <div class="modal-jasaEmas-wrapper">
			<div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <b-table v-else bordered hover
				:busy="isBusy"
				:items="jasaEmas.entries" 
				:fields="fieldsJasa" 
				responsive class="mb-3">
				<template v-slot:table-busy>
					<div class="text-center text-danger my-2">
						<b-spinner class="align-middle"></b-spinner>
						<strong>  Loading data...</strong>
					</div>
				</template>
				<template v-slot:top-row>
					<td>
						<div>Dibawah</div>
					</td>
					<td>
						<div class="text-right no-wrap" v-if="jasaEmas.dibawah !== null">Rp. {{$helper.addThousandSeparator(jasaEmas.dibawah)}} </div>
        			</td>
					<td>
						<div class="text-right no-wrap" v-if="jasaEmas.dibawahJasa1 == null">-</div>
						<div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(jasaEmas.dibawahJasa1)}} %</div>
					</td>
					<td>
						<div class="text-right no-wrap" v-if="jasaEmas.dibawahJasa2 == null">-</div>
						<div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(jasaEmas.dibawahJasa2)}} %</div>
					</td>
				</template>
				<template v-slot:cell(dari)="row">
					<div class="text-right no-wrap" v-if="row.item.dari !== null">Rp. {{$helper.addThousandSeparator(row.item.dari)}} </div>
                </template>
				<template v-slot:cell(sampai)="row">
					<div class="text-right no-wrap" v-if="row.item.sampai !== null">Rp. {{$helper.addThousandSeparator(row.item.sampai)}} </div>
                </template>
				<template v-slot:cell(jasa1)="row">
					<div class="text-right no-wrap" v-if="row.item.jasa1 == null">-</div>
					<div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.jasa1)}} %</div>
				</template>
				<template v-slot:cell(jasa2)="row">
					<div class="text-right no-wrap" v-if="row.item.jasa2 == null">-</div>
					<div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(row.item.jasa2)}} %</div>
				</template>
				<template v-slot:custom-foot>
					<td>
						<div>Diatas</div>
					</td>
					<td>
						<div class="text-right no-wrap" v-if="jasaEmas.diatas !== null">Rp. {{$helper.addThousandSeparator(jasaEmas.diatas)}} </div>
        			</td>
					<td>
						<div class="text-right no-wrap" v-if="jasaEmas.diatasJasa1 == null">-</div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(jasaEmas.diatasJasa1)}} %</div>
                    </td>
					<td>
						<div class="text-right no-wrap" v-if="jasaEmas.diatasJasa2 == null">-</div>
                        <div class="text-right no-wrap" v-else>{{$helper.addThousandSeparator(jasaEmas.diatasJasa2)}} %</div>
                    </td>
				</template>
			</b-table>
        </div>
    </b-modal>
</template>

<script>
export default {
	name: 'modal-jasa-emas',
	data(){
		return{
			isLoading: false,
			isBusy: true,
			fieldsJasa: [
				{ key: "dari", label: "Dari"},
                { key: "sampai", label: "Sampai"},
				{ key: "jasa1", label: "0 - 15 hari"},
				{ key: "jasa2", label: "16 - Jatuh Tempo"},
			],
			jasaEmas: {},
			input: {
				jasaEmas: {
					dibawah: 0,
					diatas: 0,
					dibawahJasa1: null,
					dibawahJasa2: null,
					diatasJasa1: null,
					diatasJasa2: null,
					entries: [
						{
							dari: 0,
							sampai: 0,
							jasa1: null,
							jasa2: null
						}
					]
				},
			},
		}
	},
	methods: {
		init(){
			this.isLoading = true

			let getJasaEmas = this.$axios.get("jasa-emas/").then(response => {
				this.input.jasaEmas = response.data
				this.jasaEmas.dibawah = this.$helper.addThousandSeparator(response.data.dibawah)
				this.jasaEmas.diatas = this.$helper.addThousandSeparator(response.data.diatas)
				this.jasaEmas.dibawahJasa1 = response.data.dibawahJasa1
				this.jasaEmas.dibawahJasa2 = response.data.dibawahJasa2
				this.jasaEmas.diatasJasa1 = response.data.diatasJasa1
				this.jasaEmas.diatasJasa2 = response.data.diatasJasa2
				this.jasaEmas.entries = []
				for (var x of response.data.entries) {
                    let nominalDari, nominalSampai = null
					nominalDari = this.$helper.addThousandSeparator(x.dari);
					nominalSampai = this.$helper.addThousandSeparator(x.sampai);

					this.jasaEmas.entries.push({
						dari: nominalDari,
						sampai: nominalSampai,
						jasa1: x.jasa1,
						jasa2: x.jasa2
					})
                }

            })
			
            Promise.all([getJasaEmas]).then(() => {
                this.isLoading = false
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
				this.$bvModal.hide("modal-jasa-emas");
				this.$helper.parseError(this, error)
            })

		},
		toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },
	},
	created() {
        this.init()
    }
}
</script>